import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import PermissionGroupModal from '../../PermissionGroups/NewPermissionGroup'
import OperationalTable, { useOperationalTable } from '../../../../organisms/OperationalTable'
import { useCheckPolicy } from '../../../../../hooks'
import { useAdminTabStyles } from '../../Roles/RolesView'
import { PERMISSIONS } from '../../../../../policies/admin'
import { useSearchPermissionGroups } from '../../../../../api/users'

const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'permissionGroupId', type: 'number' },
    { Header: 'Permission Group Name', accessor: 'name', type: 'string' },
    { Header: 'Description', accessor: 'description' },
    {
      Header: 'Number of Permissions',
      Cell: ({ row }) => row.original.permissions.length
    }
  ],
  defaultSort: [{ id: 'permissionGroupId', desc: true }]
}
const WealthOwnerPermissionGroupsTab = ({ modalOpen, setModalOpen }) => {
  const history = useHistory()
  const canEditWealthOwnerRoles = useCheckPolicy(PERMISSIONS.editWealthOwnerPermissions)
  const classes = useAdminTabStyles()
  const {
    searchText,
    onSearchTextChange
  } = useOperationalTable(defaultColumnConfig.defaultSort)
  const query = {
    includes: {
      permissions: true
    },
    filters: {
      assignableToUserType: 1
    }
  }
  const { data: permissionGroups = [], isLoading } = useSearchPermissionGroups(query)
  const onClickRow = useCallback((row) => {
    if (row.original && canEditWealthOwnerRoles) {
      history.push(`/admin/clients/permission-groups/${row.original.permissionGroupId}`)
    }
  }, [canEditWealthOwnerRoles, history])
  const onModalSubmit = () => {
    setModalOpen(false)
  }

  return (
    <>
      <PermissionGroupModal open={modalOpen} handleClose={onModalSubmit} permissionType={1} />
      <OperationalTable.Wrapper>
        <OperationalTable.SuperHeader className={classes.headspace}>
          <OperationalTable.Search
            onChange={onSearchTextChange}
            placeholder='Search by permission group name'
            delay={250}
          />
        </OperationalTable.SuperHeader>
        <OperationalTable
          variant='v2'
          columns={defaultColumnConfig.columns}
          mode='auto'
          defaultSort={defaultColumnConfig.defaultSort}
          data={permissionGroups}
          searchText={searchText}
          loading={isLoading}
          onRowClick={onClickRow}
        />
      </OperationalTable.Wrapper>
    </>
  )
}

WealthOwnerPermissionGroupsTab.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func
}

export default WealthOwnerPermissionGroupsTab
